/* Native variant selection only: no cart, checkout, price or inventory replacement. */
(() => {
  'use strict';
  if (window.__novocanvasHairConcealerInitialized) return;
  window.__novocanvasHairConcealerInitialized = true;
  function initialize(root) {
    if (root.dataset.nchReady) return;
    root.dataset.nchReady = 'true';
    const productArea = root.closest('[data-product-featured]') || root.closest('.shopify-section');
    const form = productArea && productArea.querySelector('form[data-type="add-to-cart-form"]');
    let variants = [];
    try {
      const source = root.querySelector('[data-nch-variants]');
      const parsed = source && JSON.parse(source.textContent);
      if (Array.isArray(parsed)) variants = parsed;
    } catch (error) { /* Native swatches still work if JSON is unavailable. */ }
    const cards = Array.from(root.querySelectorAll('.shade-card[data-nch-shade]'));
    function selectedNativeShade() {
      if (!form) return null;
      const id = form.querySelector('[name="id"]');
      const variant = id && variants.find(item => String(item.id) === String(id.value));
      return variant && (variant.option1 || (variant.options && variant.options[0]));
    }
    function syncCards(shade) {
      cards.forEach(card => {
        const selected = card.dataset.nchShade === shade;
        card.classList.toggle('selected', selected);
        if (selected) card.setAttribute('aria-current', 'true');
        else card.removeAttribute('aria-current');
      });
    }
    root.addEventListener('click', event => {
      const card = event.target.closest('.shade-card[data-nch-shade]');
      if (!card || !root.contains(card) || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      let selected = false;
      if (form) {
        const swatch = Array.from(form.querySelectorAll('[data-swatch-option][data-id="0"] [data-swatch-item]')).find(item => item.dataset.value === card.dataset.nchShade);
        if (swatch) { swatch.click(); selected = true; }
        else {
          const matches = variants.filter(item => (item.option1 || (item.options && item.options[0])) === card.dataset.nchShade);
          const nativeSelect = form.querySelector('select[name="id"]');
          if (matches.length === 1 && nativeSelect && Array.from(nativeSelect.options).some(option => option.value === String(matches[0].id))) {
            nativeSelect.value = String(matches[0].id);
            nativeSelect.dispatchEvent(new Event('change', { bubbles: true }));
            selected = true;
          }
        }
      }
      if (selected) syncCards(card.dataset.nchShade);
      const target = form || (productArea && productArea.querySelector('#nch-product'));
      if (target) {
        const top = Math.max(0, target.getBoundingClientRect().top + window.scrollY - 100);
        window.scrollTo({ top, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      }
    });
    if (form) {
      form.addEventListener('change', () => syncCards(selectedNativeShade()));
      form.addEventListener('click', event => {
        const swatch = event.target.closest('[data-swatch-option][data-id="0"] [data-swatch-item]');
        if (swatch && form.contains(swatch)) syncCards(swatch.dataset.value);
      });
      syncCards(selectedNativeShade());
    }
  }
  function initializeWithin(container) {
    if (container.matches && container.matches('[data-nch-details]')) initialize(container);
    container.querySelectorAll('[data-nch-details]').forEach(initialize);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeWithin(document), { once: true });
  else initializeWithin(document);
  document.addEventListener('shopify:section:load', event => initializeWithin(event.target));
})();
